// extracted by mini-css-extract-plugin
module.exports = {"alp":"elevations_alp__3W8Xv","tln":"elevations_tln__2WeeW","btl":"elevations_btl__25GOG"};